import SelectTeam from './selectTeam.vue'
import { changeBrandStatus } from '~/api'
import type { DataType } from '~/features/pageList'
import { useVideoView } from '~/hooks/useModal/modals/view'
import { ACCEPT } from '~/hooks/useUpload'
import { showContact } from '~/hooks/useModal/modals/contact'
import { useEmptyModal } from '~/hooks/useModal/modals/empty'
import { useShareModal } from '~/hooks/useModal/modals/share'
import { SETASBRAND } from '~/utils/track'
import Establish from '~/assets/svg/establish.svg?url'
import DarkEstablish from '~/assets/svg/establish-dark.svg?url'
import { FOLLOW_STATUS } from '~/api/interface'
import Resource from '~/components/resource/index'
import { useTime } from '~/hooks/useTime'

enum GUIDELINES {
  TRUE = 'True',
  FALSE = 'False',
}

export interface TeamProps {
  keyItem?: any
  upload: {
    resource_type: string
    accept?: string
    params?: DataType
  }
  updateData: (key: string) => void
}

export const acceptMap: any = {
  [RESOURCE_TYPE.HEAD]: ACCEPT.VIDEO,
  [RESOURCE_TYPE.END]: ACCEPT.VIDEO,
  [RESOURCE_TYPE.FONT]: ACCEPT.FONT,
  [RESOURCE_TYPE.MUSIC]: ACCEPT.AUDIO,
  [RESOURCE_TYPE.PASTER]: ACCEPT.IMAGE,
  [`${RESOURCE_TYPE.MATERIAL}_`]: `${ACCEPT.IMAGE},${ACCEPT.VIDEO},${ACCEPT.PPT},${ACCEPT.PDF}`,
  [`${RESOURCE_TYPE.MATERIAL}_${FILE_TYPE_MAP.IMAGE}`]: ACCEPT.IMAGE,
  [`${RESOURCE_TYPE.MATERIAL}_${FILE_TYPE_MAP.VIDEO}`]: ACCEPT.VIDEO,
  [`${RESOURCE_TYPE.MATERIAL}_${FILE_TYPE_MAP.PPT}`]: ACCEPT.PPT,
  [`${RESOURCE_TYPE.MATERIAL}_${FILE_TYPE_MAP.PDF}`]: ACCEPT.PDF,
}

const changeBrand = async (
  brand_ids: number[],
  brand_guidelines: GUIDELINES
) => {
  const { $t } = useNuxtApp()

  const res = await changeBrandStatus({
    brand_ids,
    brand_guidelines,
  })
  if (res.code === 0) {
    message.success(
      $t(
        'brandguidelines-guidelinestrue-txinzeng-tquxiao-pin-pai-gui-fan-cheng-gong',
        [brand_guidelines === GUIDELINES.TRUE ? $t('xin-zeng') : $t('qu-xiao')]
      )
    )
    return true
  }
  return false
}

export const menu = () => {
  const { $t } = useNuxtApp()
  return {
    share: {
      key: ActionListKey.BRAND_SHARE,
      label: $t('fen-xiang'),
      click: (record: any, _: any, keyItem?: any) => {
        const trackParams: any = {
          target: keyItem?.target,
          source: SOURCE.BRAND,
        }
        useShareModal(
          $t('fen-xiang'),
          {
            share_ids: [record.model_id],
            model_type: record.model_type,
            resource_type:
              record.resource_type !== RESOURCE_TYPE.TEMPLATE
                ? record.resource_type
                : undefined,
            media_type: record.media_type,
            is_user_upload: record.is_user_upload,
          },
          { hasShare: true, trackParams }
        )
      },
    },
    cancel: {
      key: ActionListKey.BRAND_GUIDELINES,
      label: $t('qu-xiao-pin-pai-gui-fan'),
      click: async (
        record: any,
        updataData: (key: string) => void,
        keyItem?: any
      ) => {
        if (keyItem) {
          trackEvent(TRACK_EVENT.CANCEL_BRAND_KIT, {
            target: keyItem?.target,
            source: SOURCE.BRAND,
            Batch: BATCH.ONE,
          })
        }
        const success = await changeBrand([record.id], GUIDELINES.FALSE)
        success && updataData('reload')
      },
    },
    rename: {
      key: ActionListKey.BRAND_RENAME,
      label: $t('zhong-ming-ming'),
      click: (
        _: any,
        updataData: (key: string, value: any, source?: any) => void
      ) => {
        updataData('edit', true, OPEN_ENTRANCE.MORE)
      },
    },
    play: {
      key: ActionListKey.BRAND_PLAY,
      label: $t('bo-fang-shi-pin'),
      click: (record: any, _: any, keyItem?: any) => {
        if (!record.file_url) {
          return
        }

        const trackParams: any = {
          target: keyItem?.target,
          source: SOURCE.BRAND,
          click: OPEN_ENTRANCE.MORE,
        }
        useVideoView(record.file_url, trackParams)
      },
    },
  }
}

export const getBatchs = (status?: number) => {
  const { $t } = useNuxtApp()
  if (status === FOLLOW_STATUS.FOLLOWED) {
    return []
  }

  return [
    {
      key: ActionListKey.BRAND_GUIDELINES,
      text: $t('qu-xiao-pin-pai-gui-fan'),
      onClick: async (
        checkList: number[],
        reload?: () => void,
        keyItem?: any
      ) => {
        if (keyItem) {
          trackEvent(TRACK_EVENT.CANCEL_BRAND_KIT, {
            target: keyItem?.target,
            source: SOURCE.BRAND,
            Batch: BATCH.ALL,
          })
        }
        const success = await changeBrand(checkList, GUIDELINES.FALSE)
        success && reload?.()
      },
    },
  ]
}

export const useTeam = (props: TeamProps) => {
  const onCancel = () => {
    modal.destroy()
  }
  const onOk = async (brand_ids: number[]) => {
    if (props.keyItem) {
      trackEvent(TRACK_EVENT.SET_AS_BRAND, {
        target: props.keyItem?.target,
        source: SOURCE.BRAND,
        click: SETASBRAND.BRAND,
      })
    }
    const success = await changeBrand(brand_ids, GUIDELINES.TRUE)
    if (!success) {
      return
    }

    props.updateData('reload')
    onCancel()
  }
  const modal = useEmptyModal({
    width: 918,
    content: <SelectTeam {...props} cancel={onCancel} ok={onOk} />,
  })
}

export const transData = (data: Record<string, any>, tabItem: any) => {
  const { $t } = useNuxtApp()
  const { timeFormatText } = useTime()

  return {
    ...data,
    file_url:
      tabItem.resource_type !== RESOURCE_TYPE.TEMPLATE
        ? data.file_url
        : data?.preview_video_list?.[0],
    size: data?.config?.size_format
      ? data?.config?.size_format
      : data?.media_size
        ? getFormateFileSize(data?.media_size)
        : '',
    time:
      tabItem.key === RESOURCE_TYPE.TEMPLATE
        ? $t('bian-ji-yu-timeformattextnew-datedataupdatetimegettime', [
            timeFormatText(new Date(data.update_time).getTime()),
          ])
        : undefined,
  }
}

export const SelectForTeam = (props: TeamProps) => {
  const { $t } = useNuxtApp()

  const currentTheme = useTheme()
  const isDark = computed(() => currentTheme?.value === 'dark')
  return (
    <div
      class="w-full h-full flex-center gap-x-[10px] text-font-1"
      onClick={() => useTeam(props)}
    >
      <Resource src={isDark.value ? DarkEstablish : Establish} />
      {$t('tuan-dui-kong-jian-she-li')}
    </div>
  )
}

export const EmptyContent = () => {
  const { $t } = useNuxtApp()
  return (
    <div class="w-[393px] text-center">
      <div class="text-16 font-semibold">
        {$t(
          'shi-yong-pin-pai-gui-fan-rang-shi-pin-chuang-zuo-bao-chi-pin-pai-yi-zhi-xing'
        )}
      </div>
      <div class="text-12 text-font-60 mt-[8px]">
        {$t(
          'guan-li-yuan-ke-cong-tuan-dui-kong-jian-she-li-pin-pai-gui-fan-huo-zhi-jie-zai-pin-pai-gui-fan-zhong-shang-chuan-huo-she-li-pin-pai-gui-fan-pin-pai-gui-fan-you-guan-li-yuan-guan-li-tuan-dui-ke-gen-sui-tong-zhu-ti-xia-qi-ta-tuan-dui-pin-pai-gui-fan-zhu-yan-bo-shi-ren-wu-pian-tou-pian-wei-ke-tong-guo'
        )}
        &nbsp;
        <a
          onClick={() => {
            showContact('yygw-logosc-qydz')
          }}
        >
          {$t('qi-ye-ding-zhi')}
        </a>
        &nbsp;{$t('bing-pei-zhi-dao-pin-pai-gui-fan-zhong')}
      </div>
    </div>
  )
}

export const EmptyExtra = (props: any) => {
  const { $t } = useNuxtApp()
  return (
    <div class="flex-center pt-[8px] gap-[10px_20px]">
      {!props.isTemplate && (
        <a-button
          type="primary"
          class="w-[108px]"
          onClick={() => props.uploadOpen()}
        >
          {$t('ben-di-shang-chuan')}
        </a-button>
      )}
      <a-button
        type="primary"
        ghost
        class="!px-[10px]"
        onClick={() => useTeam(props)}
      >
        {$t('tuan-dui-kong-jian-she-li')}
      </a-button>
    </div>
  )
}

export const SelectType = (props: any) => {
  const { $t } = useNuxtApp()

  if (props.value.media_type === undefined) {
    props.value.media_type = ''
  }

  const mediaTypes = [
    { value: '', label: $t('quan-bu') },
    ...useDictsToAntd('mediaType'),
  ]
  return (
    <>
      <span>{$t('lei-xing')}</span>
      <a-select
        options={mediaTypes}
        value={props.value.media_type}
        onUpdate:value={(val: any) => (props.value.media_type = val)}
        class="w-[100px]"
      />
    </>
  )
}
